// extracted by mini-css-extract-plugin
module.exports = {"modal":"SentModal_modal__1-ll9","icon":"SentModal_icon__HJLh9","body":"SentModal_body__1g9ho","button":"SentModal_button__2jCfY"};